import { REPORT_CONTRACT_ITEMS_BY_CUSTOMER } from "./actionType";
import { call, all, put, fork, takeEvery } from "redux-saga/effects";

import {
  reportContractItemsByCustomerSuccess,
  reportContractItemsByCustomerFail,
} from "./action";
import { getReportContractItemsByCustomer } from "../../helpers/fakebackend_helper";

function* reportContractItemsByCustomerSaga(action) {
  try {
    const response = yield call(
      getReportContractItemsByCustomer,
      action.payload
    );
    console.log("response", response);
    yield put(reportContractItemsByCustomerSuccess(response));
  } catch (error) {
    yield put(reportContractItemsByCustomerFail(error));
  }
}

export function* watchReportContractItemsByCustomer() {
  yield takeEvery(
    REPORT_CONTRACT_ITEMS_BY_CUSTOMER,
    reportContractItemsByCustomerSaga
  );
}

export default function* Reports() {
  yield all([fork(watchReportContractItemsByCustomer)]);
}
